<template>
  <div>
    <div class="tab_action tab_bg">
      <div class="backtop">
        <span class="btncenter">场景选择</span>
        <span class="newadd" @click="selectScene('')"
          ><i class="iconfont icon-out-column"></i>新建场景</span
        >
      </div>
      <div class="tablist" style="height: 83vh">
        <div
          class="item"
          v-for="i in scenes"
          :key="i + i.sceneId"
          @click="selectScene(i.sceneId)"
        >
          <div
            class="itemimg"
            :style="{
              backgroundImage: 'url(' + i.sceneCover + ')',
            }"
          >
            <div
              v-if="i.sceneId.length > 1"
              class="delete"
              style=""
              @click.stop="deleteScene(i.sceneId)"
            >
              删除
            </div>
          </div>
          {{ i.sceneName ? i.sceneName : i.scenetitle }}
        </div>
      </div>
    </div>
    <pagination
      v-if="mubanScenes.length != scenes.length"
      class="pull-right"
      :paginationOpt="Pagination"
      @switchPage="employeePagesFn"
      style="margin-right: 30px"
    />
  </div>
</template>

<script>
import pagination from '@/components/pagination/index.vue'
export default {
  name: 'TabScene',
  data () {
    return {
      scenes: [],
      mubanScenes: [],
      param: {
        searchText: '', type: 2, pageIndex: 0, pageSize: 12
      },
      Pagination: {
        //分页
        pageIndex: 1,
        pageSize: 12,
        totalCount: 1,
        pageCount: 0
      },
    }
  },
  created () {
    this.getTepList()
    // this.getList()

  },
  mounted () {

  },
  components: {
    pagination,
  },
  methods: {
    selectScene (id) {
      this.$emit('selector', id)
    },
    getTepList () { // 获取的是预设的场景模板
      this.get('/vup/static/config/scenes.json').then((res) => {
        // console.log('模板', res.data)
        this.mubanScenes = res.data
        this.getList()
      })
    },
    getList (cb) {
      // /scene/findSceneList
      if (this.param.pageIndex === 0) { // 如果是第一页，则拼接预设场景模板
        this.param.pageSize = this.param.pageSize - this.mubanScenes.length // 减去当前预设场景模板的数量
      }
      this.post("/scene/findSceneList", this.param).then((res) => {
        // console.log('返回的模板列表', res)
        this.param.pageSize = this.Pagination.pageSize // 如果不是第一页，请求的数量正常
        this.Pagination.totalCount = res.data[1]
        this.Pagination.pageCount = Math.ceil(this.Pagination.totalCount / this.Pagination.pageSize)
        if (this.param.pageIndex === 0) { // 同上方判断
          this.scenes = [...this.mubanScenes, ...res.data[0]]
        } else {
          this.scenes = res.data[0]
        }
      })
      !!cb && cb()//分页用到了
    },
    deleteScene (id) {
      this.post("/scene/delete", { code: id }).then((res) => {
        // console.log('返回的', res)
        if (res.status === 200) {
          this.getTepList()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        }
      })
    },
    // 分页
    employeePagesFn (pageIndex, cb) { //pageIndex --- 分页组件返回的页码，    cb ---- 主要目的是为分页加锁，固定参数
      let self = this
      self.Pagination.pageIndex = pageIndex
      self.param.pageIndex = pageIndex - 1

      self.getList(cb)
    },
  }
}
</script>

<style lang="scss" scoped>
.tablist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  flex-direction: row;
  overflow-x: hidden;
  overflow-y: auto;
  // height: calc(100% - 80px);
  height: 700px;
  margin-top: 20px;
}
.newadd {
  position: absolute;
  right: 45px;
  color: #39f;
  top: 3px;
  cursor: pointer;
}
.item {
  color: #000;
  width: 150px;
  text-align: center;
  margin-right: 30px;
  cursor: pointer;

  .itemimg {
    position: relative;
    width: 130px;
    height: 200px;
    border-radius: 5px;
    background-color: #f6f6f5;
    margin: 10px 10px;
    background-size: cover;
    overflow: hidden;
    &:hover {
      .delete {
        bottom: 0;
      }
    }
    .delete {
      color: #fff;
      position: absolute;
      // bottom: -55px;
      // width: 130px;
      bottom: -40px;
      width: 100%;

      height: 20%;
      background: #f4acb7;
      line-height: 38px;
      border-radius: 10px 10px 0 0;
      transition: all 0.3s ease 0s;
    }
  }
}
</style>